var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TableLeadCategory',{staticClass:"ma-4"}),_c('LabelExistingMatches',{staticClass:"ma-4"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }